import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Link, Typography } from '@material-ui/core'
import CustomTypography from '../../../shared/CustomTypography'
import CardBox from '../../../shared/CardBox'
import Image from '../../../shared/Image'
import slackLogo from '../../../assets/images/logos/Slack-Logo.svg'
import oracleLogo from '../../../assets/images/logos/netsuit.svg'
import asanaLogo from '../../../assets/images/logos/asana.svg'
import twilioLogo from '../../../assets/images/logos/Twilio.svg'
import googleDrive from '../../../assets/images/logos/Google_Drive_logo.svg'
import workdayLogo from '../../../assets/images/logos/Workday_logo.svg'

const useStyles = makeStyles((theme) => ({
  IntegrationsBox: {
    padding: '0',
    width: '100%',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)',
    '& a': {
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  convenience: {
    padding: '14px 16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 140,
    borderRadius: '8px 8px 0 0',
    '& svg': {
      fontSize: '17px',
    },
    [theme.breakpoints.down('1199')]: {
      minHeight: 130,
      padding: '20px 0',
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: 110,
    },
  },
  convenienceLogo: {
    maxWidth: '250px',
    [theme.breakpoints.down('1199')]: {
      maxWidth: '210px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '170px',
    },
  },

  content: {
    padding: '14px 16px',
    background: '#EEE8FC',
    display: 'flex',
    justifyContent: ' space-between',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: '0 0 8px 8px',
    transition: '.9s',

    '&:hover': {
      background: '#7C45EF',
      transition: '1s',

      '& h6': {
        color: '#ffffff',
        transition: '1s',
      },
      '& svg': {
        color: '#ffffff',
        transition: '1s',
      },
    },
    '& h6': {
      color: '#000',
      fontSize: 20,
      fontWeight: 400,
      textAlign: 'center',
      display: 'block',
      width: '100%',
      [theme.breakpoints.down('1199')]: {
        fontSize: 16,
      },
    },
    '& svg': {
      color: '#561DE2',
      fontSize: '22px',
    },
  },

  commanTitle: {
    textAlign: 'center',
    marginBottom: 100,
    '& h4': {
      fontWeight: 800,
      fontSize: 48,
      lineHeight: '58px',
      color: '#1A1A1A',
      marginBottom: 27,
      [theme.breakpoints.down('sm')]: {
        fontSize: 32,
        lineHeight: '43px',
      },
    },
    '& p': {
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '24px',
      color: theme.palette.common.black,
      [theme.breakpoints.up('sm')]: {
        maxWidth: 670,
        margin: '0 auto',
        fontSize: 18,
        lineHeight: '22px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 18,
        lineHeight: '22px',
      },
    },
  },
}))

const Integrations = () => {
  const classes = useStyles()
  const images = [
    { image: oracleLogo, content: 'Connect with finance and accounting' },
    { image: slackLogo, content: 'Chat with team members' },
    { image: asanaLogo, content: 'Share projects updates' },
    { image: twilioLogo, content: 'Video chat with team members' },
    { image: workdayLogo, content: 'Connect with corporate HR' },
    { image: googleDrive, content: 'Share your projects' },
  ]
  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item sm={7} md={9}>
          <div className={classes.commanTitle}>
            <Typography variant="h4">
              Integrated with your favorite platforms
            </Typography>
            <Typography variant="body1">
              Custom integration with other popular platforms like Slack, Google
              Drive, or production accounting software.
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        {images.map((item, i) => (
          <Grid
            item
            container
            justifyContent="flex-start"
            alignItems="center"
            xs={12}
            sm={6}
            md={4}
            key={i}
          >
            <CardBox className={classes.IntegrationsBox}>
              <div className={classes.convenience}>
                <Image
                  src={item.image}
                  alt="Contact cover"
                  className={classes.convenienceLogo}
                  lazy={false}
                />
              </div>
              <Link href="#">
                <div className={classes.content}>
                  <CustomTypography variant="h6" component="h6">
                    {item.content}
                  </CustomTypography>
                </div>
              </Link>
            </CardBox>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default Integrations
